export const deviceStatusDefaults = () => ({
  showBorder: false, displayMode: 'ring', dataSource: 'platform',
  productScope: 'all', productId: '', previewProductId: '',
  showTotal: true, showOnline: true, showOffline: true, showRate: true, showNotActive: true,
  fontSize: 16, valueSize: 28, color: '#d8f4ff', secondaryColor: '#96b6cb',
  onlineColor: '#19cfff', offlineColor: '#8798ad', notActiveColor: '#e9b65e',
  backgroundColor: 'transparent', borderColor: '#255267'
})

export function createDeviceStatus () {
  return { label: '设备在线情况', cover: 'ui/component-device-status.svg', option: {
    name: '设备在线情况', title: '设备在线情况', icon: 'el-icon-data-analysis',
    dataType: 0, data: {}, top: 0, left: 0,
    component: { width: 380, height: 260, name: 'deviceStatus', prop: 'deviceStatus' },
    option: deviceStatusDefaults()
  } }
}

export function deviceStatusStyle (input = {}) {
  const option = { ...deviceStatusDefaults(), ...input }
  const number = (value, fallback, min, max) => Number.isFinite(Number(value)) ? Math.max(min, Math.min(max, Number(value))) : fallback
  return { '--status-color': option.color, '--status-muted': option.secondaryColor,
    '--status-online': option.onlineColor, '--status-offline': option.offlineColor,
    '--status-inactive': option.notActiveColor, '--status-border': option.borderColor,
    '--status-background': option.backgroundColor,
    '--status-font-size': number(option.fontSize, 16, 10, 48) + 'px',
    '--status-value-size': number(option.valueSize, 28, 12, 100) + 'px' }
}

export function deviceStatusMetrics (snapshot, option = {}) {
  const value = key => snapshot ? snapshot[key].toLocaleString('zh-CN') : '—'
  const metrics = [
    { key: 'total', label: '设备总数', value: value('total'), visible: option.showTotal !== false },
    { key: 'online', label: '在线', value: value('online'), visible: option.showOnline !== false },
    { key: 'offline', label: '离线', value: value('offline'), visible: option.showOffline !== false },
    { key: 'rate', label: '在线率', value: snapshot && snapshot.active ? snapshot.onlineRate.toFixed(1) + '%' : '—', visible: option.showRate !== false },
    { key: 'notActive', label: '未启用', value: value('notActive'), visible: option.showNotActive !== false && snapshot && snapshot.notActive > 0 },
    // 未识别的连接状态不能被算成离线，也不能藏进在线率分母。
    { key: 'unknown', label: '未知', value: value('unknown'), visible: snapshot && snapshot.unknown > 0 }
  ]
  return metrics.filter(item => item.visible)
}

/** 静态演示只保存分类计数；总数及在线率始终重算，不接受伪造比例。 */
export function deviceStatusDemoStatistics (input = {}) {
  if (!input || typeof input !== 'object' || Array.isArray(input)) throw new Error('演示统计必须是设备分类计数')
  const count = key => {
    const raw = input[key] === undefined ? 0 : input[key]
    if (!['number', 'string'].includes(typeof raw) || String(raw).trim() === '') throw new Error('演示设备数量必须是非负整数')
    const value = Number(raw)
    if (!Number.isSafeInteger(value) || value < 0) throw new Error('演示设备数量必须是非负整数')
    return value
  }
  const online = count('online'), offline = count('offline'), notActive = count('notActive'), unknown = count('unknown')
  const active = online + offline, total = active + notActive + unknown
  if (!Number.isSafeInteger(total)) throw new Error('演示设备总数超出整数范围')
  return { kind: 'snapshot', source: 'demo', total, online, offline, notActive, unknown, active, onlineRate: active ? online * 100 / active : 0, revision: 0 }
}
